
import { useMemo } from "react";
import { GraphLink } from "./useGraphTypes";

export const useGraphMetrics = (links: GraphLink[]) => {
  const collectionLinksCount = useMemo(() => {
    return links.filter(link => link.type === 'collection').length;
  }, [links]);

  const tagLinksCount = useMemo(() => {
    return links.filter(link => link.type === 'tag').length;
  }, [links]);

  return {
    collectionLinksCount,
    tagLinksCount
  };
};
